import { render, staticRenderFns } from "./MastercardIcon.vue?vue&type=template&id=3197c60c&scoped=true"
import script from "./MastercardIcon.vue?vue&type=script&lang=js"
export * from "./MastercardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3197c60c",
  null
  
)

export default component.exports